export default "__VITE_ASSET__Dg2bPzuQ__"